// start:ng42.barrel
export * from './abmacopios-filter.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/abmacopios-filter/index.ts